<template>
  <div class="specil_notice">
    <navBack title="消息中心"></navBack>
    <div class="notice_title">
      <p>消息中心</p>
    </div>
    <div class="notice_tip">
      <p>系统发出的提醒消息</p>
      <div class="notice_tip__socql">
        <p @click="haveReadAll">全部标记为已读</p>
        <p @click="haveDeleteAll">清空消息</p>
      </div>
    </div>
    <div
      class=""
      v-for="(item, index) in noticeList"
      :key="index"
      :style="{ cursor: item.title === '留言' ? 'pointer' : '' }"
      @click="readNews(item)"
      @mouseleave="showDelete = -1"
      @mouseenter="showDelete = index"
    >
      <div class="notice_content_head">
        <span
          :style="{
            color: item.title === '留言' && item.status == '0' ? 'red' : '',
          }"
          >【{{ item.title }}】</span
        >
        <p>
          {{ item.created_at }}
        </p>
      </div>
      <div class="notice_content_body">
        <p
          :style="{
            color: item.title === '留言' && item.status == '0' ? 'red' : '',
          }"
        >
          {{ item.content }}
        </p>
        <div v-show="index == showDelete">
          <span v-show="item.status == '0'" @click="haveReadOne(item.code)"
            >标记已读</span
          >
          <span @click="haveDeleteOne(item.code)">删除</span>
        </div>
        <div class="phoneShow">
          <span v-show="item.status == '0'" @click="haveReadOne(item.code)"
            >标记已读</span
          >
          <span @click="haveDeleteOne(item.code)">删除</span>
        </div>
      </div>
    </div>
    <div style="text-align: center; margin: 20px 0">
      <el-pagination
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
      >
      </el-pagination>
    </div>
    <!-- 留言详情 -->
    <LeaveDetail ref="leaveDetail" />
  </div>
</template>

<script>
import navBack from "../../components/navBack.vue";
import LeaveDetail from "./components/leaveDetail.vue";
import {
  getList,
  getNoVipRead,
  getNoVipDelete,
  getNoVipAllRead,
  getNoVipAllDelete,
  getNoVipList,
  haveReadOne,
  haveReadAll,
  haveDeleteOne,
  haveDeleteAll,
} from "../../api/moudles/user.js";
export default {
  data() {
    return {
      leaveDetail: null,
      noticeList: [],
      showDelete: -1,
      currentPage: 1,
      totalNum: 0,
      page_size: 10,
    };
  },
  components: {
    navBack,
    LeaveDetail,
  },
  created() {
    this.getList();
  },
  methods: {
    readNews(item) {
      item.id = item.applyCode;
      this.$refs.leaveDetail.open(item);
      if (item.status == "0") {
        this.haveReadOne(item.code);
      }
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    // 获取消息列表
    async getList() {
      if (this.$store.state.user.userVip === false) {
        // 非会员getlist
        await getNoVipList({
          data: {
            pageNo: this.currentPage,
            pageSize: this.page_size,
          },
          success: (res) => {
            this.noticeList = res.data;
            this.totalNum = parseInt(res.count);
            const newArr = res.data;
            let newNum = 0;
            newArr.forEach((item) => {
              if (item.status != 1) {
                newNum++;
              }
            });
            this.$store.commit("user/SET_NOTICE_COUNT", parseInt(newNum));
          },
        });
      } else {
        await getList({
          data: {
            pageNo: this.currentPage,
            pageSize: this.page_size,
          },
          success: (res) => {
            this.noticeList = res.data;
            this.totalNum = parseInt(res.count);
            const newArr = res.data;
            let newNum = 0;
            newArr.forEach((item) => {
              if (item.status != 1) {
                newNum++;
              }
            });
            this.$store.commit("user/SET_NOTICE_COUNT", parseInt(newNum));
          },
        });
      }
    },
    // 已读一条
    async haveReadOne(codes) {
      if (this.$store.state.user.userVip === false) {
        // 非会员
        await getNoVipRead({
          data: {
            codes,
          },
          success: (res) => {
            if (res.code == 200 || res.code == 0) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          },
        });
      } else {
        // 会员已读一条
        await haveReadOne({
          data: {
            codes,
          },
          success: (res) => {
            if (res.code == 200 || res.code == 0) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          },
        });
      }
    },
    // 已读多条
    async haveReadAll() {
      if (this.$store.state.user.userVip === false) {
        // 非会员
        await getNoVipAllRead({
          success: (res) => {
            if (res.code == 200 || res.code == 0) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          },
        });
      } else {
        // 会员
        await haveReadAll({
          success: (res) => {
            if (res.code == 200 || res.code == 0) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          },
        });
      }
    },
    // 单个删除
    async haveDeleteOne(codes) {
      if (this.$store.state.user.userVip === false) {
        // 非会员
        await getNoVipDelete({
          data: {
            codes,
          },
          success: (res) => {
            if (res.code == 200 || res.code == 0) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          },
        });
      } else {
        // 会员
        await haveDeleteOne({
          data: {
            codes,
          },
          success: (res) => {
            if (res.code == 200 || res.code == 0) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          },
        });
      }
    },
    // 多个删除
    async haveDeleteAll() {
      if (this.$store.state.user.userVip === false) {
        // 非会员
        await getNoVipAllDelete({
          success: (res) => {
            if (res.code == 200 || res.code == 0) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          },
        });
      } else {
        // 会员
        await haveDeleteAll({
          success: (res) => {
            if (res.code == 200 || res.code == 0) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          },
        });
      }
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .notice_title {
    display: none;
  }

  .specil_notice {
    min-height: 700px;
    background-color: #fff;
    width: 100%;
    position: relative;
    padding-bottom: 20px;
  }

  .notice_tip {
    width: 100%;
    height: 80px;
    background-color: #fff4f4;
    display: flex;
    flex-flow: column;
    justify-content: space-evenly;
    align-items: center;
    padding-left: 20px;
    box-sizing: border-box;
    font-size: 18px;
  }

  .phoneShow {
    width: 170px;
    text-align: center;
  }

  .notice_content_body p {
    font-size: 16px;
  }

  .notice_content_body div {
    padding: 20px 0;
    display: flex;
    flex-flow: column;
    min-height: 60px;
    justify-content: space-between;
  }

  .notice_content_body div > span {
    font-size: 16px;
    color: #c22c25;
    cursor: pointer;
  }
}

@media screen and (min-width: 750px) {
  .phoneShow {
    display: none !important;
  }

  .notice_title {
    height: 60px;
    font-weight: 500;
    font-size: 22px;
    line-height: 60px;
    padding-left: 20px;
    border-bottom: 1px solid #f2f2f2;
  }

  .specil_notice {
    min-height: 800px;
    background-color: #fff;
    width: 1200px;
    position: relative;
    margin-left: -300px;
    padding-bottom: 20px;
  }

  .notice_tip {
    width: 100%;
    height: 60px;
    background-color: #fff4f4;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 20px;
    box-sizing: border-box;
    font-size: 18px;
  }

  .notice_content_body p {
    font-size: 16px;
  }

  .notice_content_body div {
    display: flex;
  }

  .notice_content_body div > span {
    font-size: 16px;
    color: #c22c25;
    cursor: pointer;
    margin-left: 20px;
  }
}

.notice_tip__socql {
  display: flex;
}

.notice_tip__socql p {
  margin: 0 20px;
  cursor: pointer;
}

.notice_content_head {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
}

.notice_content_head span {
  font-size: 18px;
  font-weight: 600;
}

.notice_content_head p {
  color: #b39999;
}

.notice_content_body {
  min-height: 50px;
  border-bottom: 1px solid #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
}
</style>
